<div class="gallery-edit-dialog">
  <p class="txt-caption gallery-edit-dialog__hint">Текущие фото (с сервера). Новые фото загружаются в буфер и отправляются по «Применить».</p>
  <div class="gallery-edit-dialog__existing" *ngIf="existingUrls.length">
    <div *ngFor="let url of existingUrls" class="gallery-edit-dialog__thumb">
      <img [src]="url" alt="Фото" />
    </div>
  </div>
  <div class="gallery-edit-dialog__new" *ngIf="newItems.length">
    <p class="txt-caption">Новые фото:</p>
    <div class="gallery-edit-dialog__new-list">
      <div *ngFor="let item of newItems; let i = index" class="gallery-edit-dialog__thumb gallery-edit-dialog__thumb--new">
        <img [src]="item.preview" alt="Новое фото" />
        <button type="button" class="gallery-edit-dialog__remove" (click)="removeNew(i)" [attr.aria-label]="'Удалить'">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="gallery-edit-dialog__actions">
    <input
      type="file"
      #fileInput
      class="gallery-edit-dialog__file-input"
      accept="image/png,image/jpeg,image/jpg"
      (change)="onFileChange($event.target.files, $event.target)"
    />
    <button type="button" class="ui-buttons ui-buttons__light-small" (click)="fileInput.click()" [disabled]="uploadLoading">
      {{ uploadLoading ? 'Загрузка...' : 'Добавить фото' }}
    </button>
  </div>
  <p class="txt-caption gallery-edit-dialog__hint">До 1 Мб. Допустимые форматы: PNG, JPG, JPEG.</p>
  <div class="gallery-edit-dialog__footer">
    <button type="button" class="ui-buttons ui-buttons__light-small" (click)="onCancel()">Отмена</button>
    <button type="button" class="ui-buttons ui-buttons__blue-small" (click)="onApply()" [disabled]="applyLoading">
      {{ applyLoading ? 'Сохранение...' : 'Применить' }}
    </button>
  </div>
</div>
